<template>
     <div @click="$emit('pageselected', num)" class="page photo_book_page_list_item portrait container">
        <div class="loader" v-if="loading"></div>
        <div class="tag">{{ num }}</div>
        <b-img-lazy :src="url" alt="" class="book_page_image"></b-img-lazy>
     </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Modal, BaseAlert } from '@/components'

export default {
    name: "photo-book-page-list-item",
    components: {
        Modal,
        BaseAlert,
    },
    props: {
        url: '',
        num: 0,
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' })
    },
    mounted() {
        console.log("Mounted bppli:"+this.url);
    },
};
</script>
<style scoped>
.landscape {
    width: 297mm;
    height: 210mm;

    width: 104px;
    height: 74px;
}

.portrait {
    height: 297mm;
    width: 210mm;

    height: 104px;
    width: 74px;
}

.page {
    background: white;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.5cm;
    box-shadow: 0 0 0.3cm rgba(0, 0, 0, 0.5);
}
    .book_page_image{
        position: absolute;
  left: 0px;
    }

    .container {
       /*border: 1px solid #DDDDDD;*/
      /* width: 200px;*/
       position: relative;
    }
    .tag {
       float: left;
       position: absolute;
       left: 0px;
       top: 0px;
       z-index: 1000;
       background-color: #92AD40;
       padding: 5px;
       color: #FFFFFF;
       font-weight: bold;
    }
    </style>